<script setup>
import { Inertia } from '@inertiajs/inertia';
import { PlusIcon } from "@heroicons/vue/outline"

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

import UserList from '@/Components/Models/User/List.vue';


const props = defineProps({
    users: {
        type: Array,
        default: () => ([]),
    },
})

function itemClicked(item){
    Inertia.visit('/users/' + item.id)
}

function addNew(){
	// if the user is admin then they should be adding users via the organisation page
	if(auth.isAdmin){
		errors.push({
			title: 'Can\'t add a user from here',
			message: 'In order to add users to an organisation, visit that organisations page and click the "Add Contact" button in their contacts list. In order to add admin users, go to the Settings page and click the "Add Admin User" button there.',
			type: 'warning',
			timeout: 25000
		})
	}
	// otherwise get the active organisation and create a new user for it
	else {
		Inertia.visit('/users/create?organisation_id=' + auth.user.organisations[0].id)
	}
}
</script>

<template>
    <SectionCard :full-width="true">

        <template #header>
			<div class="flex justify-between items-center">
				<span class="text-lg font-medium text-gray-900 mb-0">{{ auth.isAdmin ? "Users" : "Contacts" }}</span>
				<Button 
					@click="addNew" 
					color="blue"
				>
					<PlusIcon class="w-4 h-4 mr-2 inline" /> Add New
				</Button>
			</div>
        </template>
            
		<UserList :items="users" @item-clicked="itemClicked" />

        <template #footer>
			<Button 
				@click="addNew" 
				color="blue"
			>
				<PlusIcon class="w-4 h-4 mr-2 inline" /> Add New
			</Button>
        </template>

    </SectionCard>
</template>